import React from 'react';
import PropTypes from 'prop-types';
import settings from 'settings';
import * as helpers from 'library/helpers';

import REDUCER_KEY from 'reducers/reducer.keys';
import { connect } from 'react-redux';
import { list } from 'actions';

import ExtendedTable from 'components/extendedTable/extended-table';
import { TextFilter } from 'components/Filtering';
import _ from 'lodash';

const DEFAULT_TABLE_PAGE_NO = settings.APP_CONFIG.defaultTablePage;
const DEFAULT_TABLE_PAGE_SIZE = settings.APP_CONFIG.defaultTablePageSize;

class TemplateMapperUserList extends React.Component {
  static propTypes = {
    loadList: PropTypes.func.isRequired,
    listData: PropTypes.array,
    totalItems: PropTypes.number,
    inFlight: PropTypes.bool,
    selectedItemId: PropTypes.number,
    onDragStart: PropTypes.func,
    onRowClick: PropTypes.func
  };

  static defaultProps = {
    listData: [],
    totalItems: 0,
    inFlight: false,
    selectedItemId: null,
    onDragStart() {
    },
    onRowClick() {
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedItemId: props.selectedItemId,
      page: DEFAULT_TABLE_PAGE_NO,
      pageSize: DEFAULT_TABLE_PAGE_SIZE,

      sorter: {
        field: 'last_name',
        order: 'ascend'
      },
      filters: {},
      customFilters: {
        name: {
          filterDropdownVisible: false,
          filtered: false,
          contains: false,
          searchFields: ['q'],
          searchValue: ''
        }
      }
    };

    this.handleRefreshClick = this.handleRefreshClick.bind(this);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);

    this.handleTextFilterDropdownVisibleChange = this.handleTextFilterDropdownVisibleChange.bind(this);
    this.handleTextFilterInputChange = this.handleTextFilterInputChange.bind(this);
    this.handleTextFilterSearch = this.handleTextFilterSearch.bind(this);
    this.handleTextFilterClearSearch = this.handleTextFilterClearSearch.bind(this);
  }

  componentDidMount() {
    this.loadList();
  }

  setSelectedItem(itemId) {
    this.setState({ selectedItemId: itemId });
  }

  getTableColumns() {
    const { customFilters } = this.state;
    const { onDragStart } = this.props;

    return [
      {
        title: 'User',
        dataIndex: 'last_name',
        key: 'last_name',
        sorter: true,
        defaultSortOrder: 'ascend',
        filterIcon: helpers.getFilterIcon(customFilters.name.filtered),
        filterDropdownVisible: customFilters.name.filterDropdownVisible,
        filterDropdown: (
          <TextFilter
            inputRef={(el) => {
              this.nameFilterSearchInput = el;
            }}
            placeholder="Search User"
            value={customFilters.name.searchValue}
            onInputChange={value => this.handleTextFilterInputChange('name', value)}
            onOkClick={() => this.handleTextFilterSearch('name')}
            onResetClick={() => this.handleTextFilterClearSearch('name')}
          />
        ),
        onFilterDropdownVisibleChange: visible => this.handleTextFilterDropdownVisibleChange('name', visible, this.nameFilterSearchInput),
        render: (text, record) => (
          <div className="bhp-draggable" draggable onDragStart={e => onDragStart(e, record)}>
            {`${record.last_name.toUpperCase()}, ${record.first_name}`}
          </div>
        )
      },
      {
        title: '',
        dataIndex: 'is_active',
        key: 'is_active',
        width: '55px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [{
          text: 'Active',
          value: true
        }, {
          text: 'Inactive',
          value: false
        }],
        render: (text, record) => helpers.getActiveIcon(record.is_active)
      }
    ];
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selectedItemId } = this.state;
    const preventSelection = selectedItemId == null && (nextProps.selectedItemId == null || nextProps.selectedItemId < 0);
    const selectedItemChanged = selectedItemId !== nextProps.selectedItemId;

    if (!preventSelection && selectedItemChanged) {
      this.setSelectedItem(nextProps.selectedItemId);
    }
  }

  loadList() {
    const { loadList: dispatchLoadList } = this.props;
    const {
      sorter, filters, customFilters, page, pageSize
    } = this.state;
    const sortBy = helpers.getSortField(sorter);
    const fieldFilters = helpers.getFieldFilters(filters);
    const customFieldFilters = helpers.getCustomFilters(customFilters);
    const filterBy = customFieldFilters.concat(fieldFilters);

    dispatchLoadList(page - 1, pageSize, filterBy, sortBy);
  }

  handleRefreshClick() {
    this.loadList();
  }

  handleRowClick(rowItem) {
    const { onRowClick } = this.props;
    this.setSelectedItem(rowItem.id);
    onRowClick(rowItem);
  }

  handleTableChange(pagination, filters, sorter) {
    this.setState((prevState) => {
      const page = (!_.isEqual(prevState.filters, filters) ? 1 : pagination.current);
      return helpers.getTableState(page, pagination.pageSize, filters, sorter);
    }, () => {
      this.loadList();
    });
  }

  handleTextFilterDropdownVisibleChange(key, visible, searchInput) {
    this.setState(prevState => ({
      customFilters: helpers.showFilterDropdown(prevState.customFilters, key, visible)
    }), () => {
      searchInput && searchInput.focus();
    });
  }

  handleTextFilterInputChange(key, text) {
    this.setState(prevState => ({
      customFilters: helpers.getTextFilterInputChange(prevState.customFilters, key, text)
    }));
  }

  handleTextFilterSearch(key) {
    this.setState(prevState => ({
      customFilters: helpers.getTextFilterSearchValue(prevState.customFilters, key),
      page: 1
    }), () => {
      this.loadList();
    });
  }

  handleTextFilterClearSearch(key) {
    this.setState(prevState => ({
      customFilters: helpers.clearTextFilterSearchValue(prevState.customFilters, key),
      page: 1
    }), () => {
      this.loadList();
    });
  }

  render() {
    const { listData, totalItems, inFlight } = this.props;
    const { selectedItemId, page, pageSize } = this.state;

    const commands = {
      showAdd: false,
      showDelete: false
    };
    const rowSelectionConfig = {
      selectItemOnSingleClick: false,
      selectItemOnDoubleClick: false,
      highlightRow: false
    };
    const selectedRowKeys = selectedItemId == null || selectedItemId < 0 ? [] : [selectedItemId];
    const scroll = {
      x: 290,
      y: '100%'
    };

    return (
      <ExtendedTable
        loading={inFlight}
        title="Select User"
        className="bhp-user-list bhp-container"
        commands={commands}
        dataSource={listData}
        columns={this.getTableColumns()}
        rowKey="id"
        rowSelectionConfig={rowSelectionConfig}
        selectedRowKeys={selectedRowKeys}
        scroll={scroll}
        page={page}
        pageSize={pageSize}
        totalRecords={totalItems}
        onCommandRefreshClick={this.handleRefreshClick}
        onRowClick={this.handleRowClick}
        onTableChange={this.handleTableChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  listData: state.api.peopleData.data.results,
  totalItems: state.api.peopleData.data.count,
  inFlight: state.api.peopleData.inFlight,
  isDirty: state.api.peopleData.isDirty
});

const mapDispatchToProps = dispatch => ({
  loadList(page, pageSize, filters, sorted) {
    return dispatch(list(REDUCER_KEY.peopleData.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateMapperUserList);
